<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 10C3.55228 10 4 9.55228 4 9C4 8.44772 3.55228 8 3 8C2.44772 8 2 8.44772 2 9C2 9.55228 2.44772 10 3 10Z"
    fill="var(--iconPrimary, #292929)" />
  <path d="M3 6C3.55228 6 4 5.55228 4 5C4 4.44772 3.55228 4 3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6Z"
    fill="var(--iconPrimary, #292929)" />
  <path d="M3 2C3.55228 2 4 1.55228 4 1C4 0.447715 3.55228 0 3 0C2.44772 0 2 0.447715 2 1C2 1.55228 2.44772 2 3 2Z"
    fill="var(--iconPrimary, #292929)" />
  <path d="M7 10C7.55228 10 8 9.55228 8 9C8 8.44772 7.55228 8 7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10Z"
    fill="var(--iconPrimary, #292929)" />
  <path d="M7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6Z"
    fill="var(--iconPrimary, #292929)" />
  <path d="M7 2C7.55228 2 8 1.55228 8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1C6 1.55228 6.44772 2 7 2Z"
    fill="var(--iconPrimary, #292929)" />
</svg>